import CreatorAlbumFeedsComponent from "./CreatorAlbumFeedsComponent";
export default CreatorAlbumFeedsComponent;
